<template>
  <PanelPage ref="useAlerts" :loading-overlay="loadingOverlay" md="12">
    <v-card>
      <v-card-title>Download Receipt</v-card-title>
      <v-card-title>
        <v-row class="mb-0">
          <v-col>
            <v-autocomplete
              label="File Name (Money Destination at moment of creation)"
              :items="receiptNames"
              v-model="receiptName"
              hide-details
            />
          </v-col>
          <v-col>
            <v-autocomplete
              label="Dates"
              :items="receiptDates"
              v-model="receiptDate"
              hide-details
            />
          </v-col>
          <v-col cols="auto" class="d-flex">
            <v-btn class="fill-height" :disabled="receiptName === null || receiptDate ===null"
                   @click="startDownloadReceipt">
              Retrieve
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
    </v-card>
  </PanelPage>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import axios from 'axios';
import { comparatorICase } from "../utils.js";
import PanelPage from "../components/PanelPage.vue";
import { endpoint } from "../remote/utils.js";

// State
const useAlerts = ref(null);
const loadingOverlay = ref(false);
const receipts = ref(new Map());
const receiptName = ref(null);
const receiptDate = ref(null);

async function retrieveReceipts() {
  const res = await axios.get(endpoint("get_receipts/"), {
    withCredentials: true
  });
  const raw_data = res.data['receipts'];  // List of filenames try_v222_2023-11-01_2023-12-01.pdf
  let data = new Map();
  for (const rec of raw_data) {
    let parts = String(rec).split("_");
    const endDate = parts.pop().split('.')[0];
    const startDate = parts.pop();
    const date = [startDate, endDate].join("_");
    const reportName = parts.join("_");
    data.set(reportName, [...(data.get(reportName) || []), date]);
  }
  return data;
}

const receiptNames = computed(() => {
  return [...receipts.value.keys()].sort((a, b) => comparatorICase(a, b));
});

const receiptDates = computed(() => {
  if (receiptName.value === null) return [];
  return [...receipts.value.get(receiptName.value)].sort((a, b) => -comparatorICase(a, b));
});

onMounted(async () => {
  loadingOverlay.value = true;
  try {
    receipts.value = await retrieveReceipts();
    console.log(receipts.value);
  } catch (e) {
    useAlerts.value.errorAlert('Error during Receipts list retrieve', e.toString());
  }
  loadingOverlay.value = false;
});

function startDownloadReceipt() {
  const fullReceiptName = [receiptName.value, receiptDate.value].join('_') + '.pdf';
  const url = endpoint(`download_receipt/${fullReceiptName}`);
  window.open(url, '_blank');
}
</script>

<style scoped>

</style>
